// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"188":"387c4638","657":"f827907f"}[chunkId] + ".chunk.css";
};